/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown>, pool: NonNullable<unknown> }} Usage_Status_Headline_Contract_Pool_OnlyInputs */



/**
* | output |
* | --- |
* | "You have used {used} of your {pool} prepaid credit." |
*
* @param {Usage_Status_Headline_Contract_Pool_OnlyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_status_headline_contract_pool_only = /** @type {((inputs: Usage_Status_Headline_Contract_Pool_OnlyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Status_Headline_Contract_Pool_OnlyInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Sie haben ${i?.used} von Ihrem vorausbezahlten Guthaben über ${i?.pool} verbraucht.`)
	return /** @type {LocalizedString} */ (`You have used ${i?.used} of your ${i?.pool} prepaid credit.`)
});